<template>
  <v-layout class="flex-column">
    <v-layout wrap fill-height>
      <headband-text
        :title="$t('page.markets.title')"
        :overline="$t('page.markets.overline')"
      />
      
      <v-container class="py-10">
        <v-row v-if="markets.AL.length !== 0">
          <v-col
            cols="12"
            class="mb-3"
            v-for="key in sortMarkets"
            :key="key"
          >
            <h2 class="v-row-title display-1 d-flex align-center mb-3">
              <market-icons :items="[markets[key][0].marche]" />
              <span>
                <span class="ml-0" v-if="key !== 'null'">
                  {{ i18nTermsGroupsLabel('markets', key) }}
                </span>
                <small class="subtitle-1 font-weight-light">{{ $tc('theme.documentCount', [markets[key][0].count]) }} - <router-link :to="{ name: 'SingleMarkets', params: { market: key.toLowerCase() }}">{{$t('btn.allDocuments')}}</router-link></small>
              </span>
            </h2>

            <v-row v-if="markets[key].length !== 0 && sectors.length !== 0">
              <v-col cols="12" sm="6" md="4" lg="3" v-if="findSectors(key).length !== 0">
                <v-card elevation="2">
                  <v-list dense>
                    <v-subheader>{{$t('theme.sectors')}}</v-subheader>
                    <v-list-item-group v-model="item" color="primary">
                      <v-list-item
                        v-for="sector in findSectors(key)"
                        :key="sector.secteur"
                        :to="{
                          name: 'SingleSectors',
                          params: {
                            market: key.toLowerCase(),
                            sector: sector.secteur.toLowerCase(),
                          }
                        }"
                      >
                        <v-list-item-icon class="align-items-center">
                          <span
                            :style="`background:${i18nTermsGroups('sectors', sector.secteur).color};height:18px;width:18px;display:flex;`"
                          ></span>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                             <span>{{ i18nTermsGroupsLabel('sectors', sector.secteur) }}</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        :to="{
                          name: 'SingleSectors',
                          params: {
                            market: key.toLowerCase(),
                            sector: 'empty',
                          }
                        }"
                      >
                        <v-list-item-icon class="align-items-center">
                          <span
                            :style="`background:#333;height:18px;width:18px;display:flex;`"
                          ></span>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                             <span>{{ $t('theme.notClassified') }}</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-col>
              <v-col
                cols="12" sm="6" md="4" lg="3"
                class="d-none d-sm-block mb-2"
                v-for="document in findMarkets(markets[key][0].entries, key)"
                :key="document.fid"
              >
                <document :pump="document"></document>
              </v-col>
            </v-row>
            <v-row v-if="markets[key].length === 0">
              <v-col cols="12" sm="6">
                <v-alert
                  icon="mdi-information-outline"
                  prominent
                  text
                  type="info"
                  class="mb-0"
                >
                  <span v-html="$t('page.markets.message.noresult', [i18nTermsGroupsLabel('markets', markets[key][0].marche)])" />
                </v-alert>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-layout>
    <block-newsletter v-if="!isLoad" />
   </v-layout>
</template>
<script>
import { groupBy } from '@/core/utils'
import Mixins from '@/core/mixins'
import MarketIcons from '@/components/file/Markets'
export default {
  name: 'GroupMarkets',
  mixins: [ Mixins ],
  data() {
    return {
      isLoad: true,
      markets: {
        AL: [],
        GL: [],
        WL: [],
        IL: [],
        FL: [],
      },
      sectors: []
    }
  },

  components: {
    HeadbandText: () => import(/* webpackChunkName: "HeadbandText" */ '@/modules/headband/HeadbandText'),
    BlockNewsletter: () => import(/* webpackChunkName: "BlockNewsletter" */ '@/modules/block/BlockNewsletter'),
    Document: () => import(/* webpackChunkName: "Document" */ '@/components/layout/Document'),
    MarketIcons,
  },

  created () {
    this.handlerMarkets()
    this.handlerSectors()
  },

  mounted() {
    this.$ga.page('/markets');
  },

  computed: {
    sortMarkets () {
      return Object.keys(this.markets)
        .map(f => f.toString())
        .filter(Boolean)
    },
  },

  methods: {

    async handlerMarkets () {
      const response = await this.request(`/search/market`)
      const groupByDocs = groupBy(response, 'marche')
      this.markets = groupByDocs
    },

    findMarkets (data, key) {
      const findSectors = this.sectors.filter(s => s.secteur.startsWith(key))

      let output = findSectors.length === 0 ? data : data.slice(0, 3)
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return []
        case 'sm': return data.slice(0, 1)
        case 'md': return data.slice(0, 2)
        case 'lg': return output
      }
  
      return output
    },

    async handlerSectors () {
      this.sectors = await this.request(`/search/sector`)
      this.isLoad = false
    },

    findSectors (key) {
      return this.sectors.filter(s => s.secteur.startsWith(key))
    },
  }
}
</script>
